/**
 * Maps the IDs of the items in the array.
 *
 * @param {Array} items - The array of items to map.
 * @returns {Array} - The array of IDs.
 */
export const mapIds = (items) => items?.map((item) => item.id || item) || [];

export const getGroupToExpand = (groupedItems) => {
  const firstGroup = groupedItems[0];
  const secondGroup = groupedItems[1];
  if (firstGroup?.noOfItems > 0) {
    return [firstGroup.id];
  }
  if (firstGroup?.noOfItems === 0 && firstGroup?.isDefault && secondGroup?.noOfItems > 0) {
    return [secondGroup.id];
  }
  return [];
};
